import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

export class BriefingDateFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    placeholder: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        placeholder?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.placeholder = placeholder;
    }
}
